<template>
  <div>
    <com-table :columns="columns" :api="api" ref="tableRef" :defaultParams="defaultParams">
      <template #createTime="row">
        {{ row.data.createTime | formatDate }}
      </template>
      <template #operation="row">
        <el-button type="primary" @click="handleCheck(row.data)" size="mini" class="mb-5rpx"
          >查看</el-button
        >
        <el-button type="primary" @click="handleEdit(row.data)" size="mini" class="mb-5rpx"
          >编辑</el-button
        >
        <el-button type="danger " @click="handleDel(row.data)" class="mb-5rpx" size="mini"
          >删除</el-button
        >
      </template>
      <template #status="row">
        <el-switch
          v-model="row.data.status"
          :active-value="1"
          :inactive-value="0"
          @change="handleStatus(row.data)"
        >
        </el-switch>
      </template>
    </com-table>
    <com-add-business ref="shopRef" @success="update"></com-add-business>
  </div>
</template>

<script>
import {
  partnersListApi as listApi,
  delPartnerApi as delBusinessApi,
  parentsStatusApi as businessStatusApi
} from '@/api/partners'

export default {
  data() {
    return {
      api: listApi,
      defaultParams: {
        type: 2
      },
      columns: [
        {
          label: '商家编号',
          prop: 'number',
          width: '150'
        },
        {
          label: '商家名称',
          prop: 'businessName',
          minWidth: '150'
        },
        {
          label: '商家地址',
          prop: 'address',
          auto: true
        },
        {
          label: '联系人',
          prop: 'name',
          minWidth: '120'
        },
        {
          label: '联系电话',
          prop: 'phone',
          width: '150'
        },
        {
          label: '关联网点数',
          prop: 'storeCount',
          width: '100'
        },
        {
          label: '设备数',
          prop: 'deviceCount'
        },
        {
          label: '订单量',
          prop: 'orderCount'
        },
        {
          label: '分成收入',
          prop: 'deviceIncome',
          width: '100'
        },
        {
          label: '状态',
          prop: 'status',
          type: 'slot',
          slotName: 'status'
        },
        {
          label: '创建时间',
          prop: 'createTime',
          type: 'slot',
          slotName: 'createTime',
          width: '120'
        },
        {
          label: '操作',
          prop: 'operation',
          slotName: 'operation',
          type: 'slot',
          minWidth: '180',
          fixed: 'right'
        }
      ]
    }
  },
  methods: {
    update() {
      this.$refs.tableRef.getList()
    },
    handleDel(row) {
      this.$confirm('此操作将永久删除该商家, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const param = {
            code: row.code
          }
          delBusinessApi(param).then(() => {
            this.$refs.tableRef.getList()
          })
        })
        .catch(() => {})
    },
    handleStatus(val) {
      const param = {
        status: val.status,
        code: val.code
      }
      businessStatusApi(param).then(() => {
        this.update()
      })
    },
    handleCheck(row) {
      this.$router.push({ name: 'shop-detail', params: row })
    },
    handleEdit(row) {
      const param = {
        type: 'edit',
        row
      }
      this.$refs.shopRef.open(param)
    },
    created() {
      const param = {
        type: 'created'
      }
      this.$refs.shopRef.open(param)
    },
    search(val) {
      console.log('handleSearch :>> ', val)
      this.$refs.tableRef.search(val)
    }
  }
}
</script>
